import type { OutputMapping } from '../../shared/output-mappings';

// Field keys (or substrings) that tend to carry an agent's headline judgment. Used only to seed a
// default set of output mappings when a freshly-selected agent version has no surviving mappings.
// Easily tunable as agent conventions evolve.
const IMPORTANT_OUTPUT_KEYS = ['disposition', 'recommendation', 'overall_recommendation'];
const IMPORTANT_OUTPUT_SUBSTRINGS = [
  'overall',
  'final',
  'decision',
  'determination',
  'result',
  'recommendation',
  'conclusion',
  'verdict',
  'outcome',
  'assessment',
];

const isImportantOutput = (fieldKey: string): boolean => {
  const key = fieldKey.toLowerCase();
  return IMPORTANT_OUTPUT_KEYS.includes(key) || IMPORTANT_OUTPUT_SUBSTRINGS.some(substring => key.includes(substring));
};

/**
 * Picks a sensible default set of output mappings from an agent version's public output field keys,
 * keying each chosen output to its own field key. Returns the "headline" outputs (by name heuristic)
 * in their original order; may be empty when nothing looks important, in which case the author maps
 * outputs manually.
 */
export const getDefaultOutputs = (availableFieldKeys: string[]): OutputMapping[] =>
  availableFieldKeys
    .filter(isImportantOutput)
    .toSorted((a, b) => a.localeCompare(b))
    .map(fieldKey => ({ fieldKey, onboardingDataKey: fieldKey }));
